export * from './FileTypeRenderer.module.scss';
export * from './FileTypeRenderer';